import { render, staticRenderFns } from "./ManageUserBillingHistoryTab.vue?vue&type=template&id=cbcb7816"
import script from "./ManageUserBillingHistoryTab.vue?vue&type=script&lang=js"
export * from "./ManageUserBillingHistoryTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports